import { ReviewFeedbackCriticality } from 'shared/domains/apollo/generated/types';
const criticalityMap = {
    [ReviewFeedbackCriticality.Critical]: 'danger',
    [ReviewFeedbackCriticality.Notable]: 'warning',
    [ReviewFeedbackCriticality.Minor]: 'info',
};
export const getAvatarAppearance = (criticality) => criticalityMap[criticality];
